// Detects whether the current host is a TENANT subdomain (e.g. mialojamiento.kanarix.online)
// vs the main app/landing. Tenant sites are served from their own subdomain so each has
// isolated SEO and never pollutes the Kanarix domain. Returns the slug, or null for the
// app itself (app/www/demo), the apex, *.pages.dev previews, and localhost.
// The base domain + reserved-label list live in shared/tenant.ts (single source of
// truth, also used by the Pages middleware and the kanarix-sites Worker).
import { getTenantLabel } from '../../shared/tenant';

export function getTenantSubdomain(host: string = typeof window !== 'undefined' ? window.location.hostname : ''): string | null {
  return getTenantLabel(host);
}
